export const CONFLICT_ERROR_MESSAGE = 'error.schedule-conflict';
export const UNIT_UNAVAILABLE = 'error.unit-unavailable';
export const NO_PRICING = 'error.no-pricing';
export const PAYMENT_ERROR = 'error.payment';
export const ONGOING_WIDGET_BOOKING = 'error.ongoing-widget-booking';
export const BOOKING_NOT_FOUND = 'error.booking-not-found';
export const BOOKING_PROBLEM = 'error.booking-problem';
export const OVERLAPPING_BLOCK_PERIOD = 'Overlapping period';
export const BOOKING_IN_BLOCK_PERIOD = 'Booking exists in the given blocked period';
